<template>
  <span
    :class="[
      payment.transactionMethod === 'pos_card'
        ? 'bg-card'
        : payment.transactionMethod === 'pos_cash'
          ? 'bg-cash'
          : payment.transactionMethod === 'split'
            ? 'bg-primary'
            : 'bg-background-fg/40',
      'text-background inline-flex items-center justify-center rounded-full px-2 py-px text-xs',
    ]"
  >
    <template
      v-if="
        payment.transactionMethod === 'pos_card' &&
        'cardNumberLast4' in payment
      "
    >
      <template v-if="cardSchemeIcon">
        <Component :is="cardSchemeIcon" class="mr-1" />
      </template>
      {{ payment.cardNumberLast4 }}
    </template>

    <template
      v-else-if="payment.transactionMethod === 'pos_cash'"
    >
      <CashIcon class="mr-1" />
      Cash
    </template>

    <template
      v-else-if="payment.transactionMethod === 'split'"
    >
      Split
    </template>

    <template v-else> - </template>
  </span>
</template>

<script setup lang="ts">
import type {
  PaymentDetailCard,
  PaymentDetailCash,
  PaymentDetailSplit,
} from "@/services/sharedTypes/invoices"
import type { TransactionDetailUnknown } from "@/services/sharedTypes/transactions"
import CashIcon from "~icons/ri/cash-fill"

const props = defineProps<{
  payment:
    | PaymentDetailCard
    | PaymentDetailCash
    | PaymentDetailSplit
    | TransactionDetailUnknown
}>()

const cardSchemeIcon = computed(() =>
  "cardScheme" in props.payment
    ? getCardSchemeIcon(props.payment.cardScheme)
    : undefined
)
</script>
